import { ProductVendor } from "@components/videos/enums/CameraProductType";
import { IProduct } from "@interfaces/IProduct";
import { IBasicProductModel } from "@interfaces/IProductUiViewModel";

export class ProductService {

    static $inject = ["$http"];

    constructor(private readonly $http: angular.IHttpService) {

    }

    getProducts(): angular.IPromise<IProduct[]> {
        return this
            .$http({
                url: "/api/products",
                method: "GET",
                cache: true,
                params: { minsToLive: 60/*, invalidateCache: invalidateCache */}
            })
            .then((response: angular.IHttpPromiseCallbackArg<IProduct[]>) => {
                return response.data;
            });
    }

    getProductByPeripheral(serial: string, invalidateCache = false): angular.IPromise<IProduct> {
        return this
            .$http({
                url: `/api/products/peripheral/${serial}`,
                method: "GET",
                cache: true,
                params: { minsToLive: 60 }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IProduct>) => {
                return response.data;
            });
    }

    getProductByUnit(serial: string, invalidateCache = false): angular.IPromise<IProduct> {
        return this
            .$http({
                url: `/api/products/unit/${serial}`,
                method: "GET",
                cache: true,
                params: { minsToLive: 60 }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IProduct>) => {
                return response.data;
            });
    }

    getProductsByVehicle(id: number, invalidateCache = false): angular.IPromise<IProduct[]> {
        return this
            .$http({
                url: `/api/products/vehicle/${id}`,
                method: "GET",
                cache: true,
                params: { minsToLive: 60 }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IProduct[]>) => {
                return response.data;
            });
    }

    getProductUiViewModels(): angular.IPromise<IBasicProductModel[]> {
        return this
            .$http({
                url: `/api/products/basic`,
                method: "GET",
                cache: true,
                params: { minsToLive: 60 }
            })
            .then((response: angular.IHttpPromiseCallbackArg<IBasicProductModel[]>) => {
                return response.data;
            });
    }

    getProductVendorString(product: IBasicProductModel): string {
        if (!product) {
            return "No product found";
        }

        return ProductVendor[product?.GroupId] || "Unknown";
    }

    sortProductsByGroup(products: IProduct[]) {
        products.sort((a, b) => {
            // First, compare GroupId
            if (a.GroupId && b.GroupId) {
                if (String(ProductVendor[a.GroupId]) < String(ProductVendor[b.GroupId])) return -1;
                if (String(ProductVendor[a.GroupId]) > String(ProductVendor[b.GroupId])) return 1;
            } else if (a.GroupId) {
                return -1;
            } else if (b.GroupId) {
                return 1;
            }

            // If GroupId is the same, compare Description
            if (a.Description && b.Description) {
                return a.Description.localeCompare(b.Description);
            } else if (a.Description) {
                return -1;
            } else if (b.Description) {
                return 1;
            }

            // If both GroupId and Description are missing or equal, maintain original order
            return 0;
        });
    }
}
